import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { CloseIcon, HamburgerMenuIcon } from "@flat-ui";
import { Box, Grid } from "@mui-wrapper";
/** Sizes of the header buttons, slightly larger than the default for easier tapping */
const BUTTON_SIZE = "2.75rem";
const ICON_SIZE = "1.75rem";

/** Fits the large avatar of the tab selection, so the menu button stays in place when toggling */
const HEADER_MIN_HEIGHT = "3.75rem";
/**
 * Header for the mobile account settings screens: a menu button on the left,
 * the header content in the middle and an optional close button on the right,
 * all vertically centered.
 */
export function AccountSettingsMobileHeader(t0) {
  const $ = _c(15);
  const {
    menuLabel,
    onMenuClick,
    onCloseClick,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      px: 1,
      pt: 5,
      alignItems: "center",
      flexWrap: "nowrap",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== menuLabel) {
    t2 = {
      "aria-label": menuLabel
    };
    $[1] = menuLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onMenuClick || $[4] !== t2) {
    t3 = <SphereIconButton component={HamburgerMenuIcon} onClick={onMenuClick} buttonSize={BUTTON_SIZE} iconSize={ICON_SIZE} dataTestId="account-settings-mobile-menu-button" iconButtonProps={t2} />;
    $[3] = onMenuClick;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flexGrow: 1,
      minWidth: 0,
      minHeight: HEADER_MIN_HEIGHT,
      display: "flex",
      alignItems: "center"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children) {
    t5 = <Box sx={t4}>{children}</Box>;
    $[7] = children;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onCloseClick) {
    t6 = onCloseClick && <SphereIconButton component={CloseIcon} onClick={onCloseClick} buttonSize={BUTTON_SIZE} iconSize={ICON_SIZE} dataTestId="account-settings-mobile-close-button" iconButtonProps={{
      "aria-label": "Close Account Settings"
    }} />;
    $[9] = onCloseClick;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t5 || $[13] !== t6) {
    t7 = <Grid container={true} sx={t1}>{t3}{t5}{t6}</Grid>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}